import { html } from "../lib/bind";

export type BankingSubNavActive = "transactions" | "import" | "reconciliation" | "transfers";

const ITEMS: { key: BankingSubNavActive; path: string; label: string }[] = [
  { key: "transactions", path: "/banking", label: "Transactions" },
  { key: "import", path: "/banking/import", label: "Import Statements" },
  { key: "reconciliation", path: "/banking/reconciliation", label: "Reconciliation" },
  { key: "transfers", path: "/banking/transfers", label: "Transfer Suggestions" },
];

/** Shared sub-nav for the 4 Banking pages (Phase 5e) — each page's header shows
 * buttons for the other 3, so the active page's own button never appears as a dead
 * self-link. No text label alongside the buttons: the topbar already carries "Banking"
 * for every /banking/* path (shell.ts's prefix-match active-nav-label), so repeating
 * it here would be exactly the double-header problem this phase set out to remove.
 * Reuses .invoice-actions' button-group spacing (already reused outside Invoices, by
 * VAT's report-card actions) rather than inventing a new utility class. */
export function buildBankingSubNav(active: BankingSubNavActive): Node {
  const fragment = html`<div class="page-header">
    <div class="invoice-actions"></div>
  </div>`;
  const actions = fragment.querySelector(".invoice-actions");
  if (!actions) throw new Error("banking subnav produced no element");
  for (const item of ITEMS) {
    if (item.key === active) continue;
    const link = document.createElement("a");
    link.href = item.path;
    link.dataset.link = "";
    link.className = "btn";
    link.textContent = item.label;
    actions.appendChild(link);
  }
  return fragment;
}
